var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0524 3.14457C11.5751 2.48633 9.92461 2.32326 8.34706 2.67968C6.76951 3.03611 5.34943 3.89294 4.29863 5.12238C3.24782 6.35182 2.62259 7.888 2.51618 9.50181C2.40976 11.1156 2.82787 12.7206 3.70814 14.0774C4.58841 15.4341 5.88368 16.47 7.40077 17.0305C8.91786 17.591 10.5755 17.6461 12.1264 17.1875C13.6774 16.7289 15.0385 15.7813 16.0069 14.4859C16.9753 13.1906 17.499 11.6169 17.4999 9.99957V9.23338C17.4999 8.77315 17.873 8.40005 18.3333 8.40005C18.7935 8.40005 19.1666 8.77315 19.1666 9.23338V10.0001C19.1655 11.9768 18.5254 13.9006 17.3418 15.4839C16.1582 17.0671 14.4946 18.2253 12.599 18.7858C10.7034 19.3462 8.67741 19.2789 6.82318 18.5939C4.96896 17.9089 3.38585 16.6428 2.30997 14.9845C1.23408 13.3262 0.723061 11.3646 0.853122 9.39215C0.983184 7.41971 1.74736 5.54216 3.03168 4.03951C4.31599 2.53686 6.05164 1.48963 7.97976 1.05399C9.90788 0.618361 11.9252 0.817669 13.7308 1.62219C14.1512 1.80951 14.3401 2.30216 14.1528 2.72255C13.9655 3.14294 13.4728 3.33189 13.0524 3.14457Z",
    fill: "#00B86A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9224 2.74378C19.248 3.06906 19.2482 3.59669 18.923 3.92229L10.5896 12.264C10.4334 12.4204 10.2214 12.5083 10.0003 12.5083C9.7792 12.5084 9.56716 12.4206 9.41083 12.2643L6.91083 9.76426C6.58539 9.43882 6.58539 8.91118 6.91083 8.58574C7.23626 8.26031 7.7639 8.26031 8.08934 8.58574L9.99979 10.4962L17.7439 2.74437C18.0691 2.41877 18.5968 2.41851 18.9224 2.74378Z",
    fill: "#00B86A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast-success.251ade42012f7ee6890bf244703a3859.svg";
export { ForwardRef as ReactComponent };